import { render, staticRenderFns } from "./BigScheme.vue?vue&type=template&id=51c21090&"
import script from "./BigScheme.vue?vue&type=script&setup=true&lang=js&"
export * from "./BigScheme.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BigScheme.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports